/* eslint-disable import/order */
import { customerServiceOrganizationDetailsEntryPoint } from '@jira/spa-apps__customer-service-organization-details/src/customerServiceOrganizationDetailsEntryPoint.entrypoint.tsx';
import { l1CustomersProjectProviderResource } from '@jira/router-resources__customer-service-l1-customers-project-provider/src/l1CustomersProjectProviderResource.tsx';
import { EntitlementsEntitlementsQueryResource } from '@jira/router-resources__service-desk-customer-service-organization-details/src/EntitlementsEntitlementsQueryResource.tsx';
import { OrganizationDetailsPageQueryResource } from '@jira/router-resources__service-desk-customer-service-organization-details/src/OrganizationDetailsPageQueryResource.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { customerServiceOrganizationDetailsRoute } from '@jira/router-routes__customer-services-customers-routes/src/customerServiceOrganizationDetailsRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { jsmEmailDomainsListResource } from '@jira/router-resources__get-email-domains-list/src/jsmEmailDomainsListResource.tsx';
import { productsJsmOrganizationDetailsResource } from '@jira/router-resources__organization-details/src/productsJsmOrganizationDetailsResource.tsx';
import type { Route } from '@atlassian/react-resource-router';

const customerServiceOrganizationDetailsPageEntryPoint = createPageEntryPoint({
	main: customerServiceOrganizationDetailsEntryPoint,
});

export const customerServiceOrganizationDetailsRouteEntry: Route = createEntry(
	customerServiceOrganizationDetailsRoute,
	() => ({
		group: 'customer-service',
		perfMetricKey: 'customer-service.organization-details',
		layout: globalLayout,

		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,

		entryPoint() {
			return fg('berry-6285-customers-l1')
				? customerServiceOrganizationDetailsPageEntryPoint
				: undefined;
		},

		resources: [
			...getNavigationResources(),
			OrganizationDetailsPageQueryResource,
			EntitlementsEntitlementsQueryResource,
			productsJsmOrganizationDetailsResource,
			jsmEmailDomainsListResource,
			l1CustomersProjectProviderResource,
		],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
